// extracted by mini-css-extract-plugin
export default {"koi":"koi___WL81S","textContent":"textContent___HyvC4","modalContent":"modalContent___sbSWD","TextArea":"TextArea___d5PYO"};